<template>
	<el-container id="pedidos">
		<el-row :class="!responsive.isMobile ? 'header' : 'headerMobile'">
			<h6 style="padding-left: 20px;" v-if="!responsive.isMobile">{{ tituloResumen.toUpperCase() }}</h6>
			<el-row type="flex" justify="space-between">
				<el-col :xs="18" :sm="24" :md="24" :lg="24" :xl="24">
					<template v-if="responsive.isMobile">
						<p class="titleMobile">Pedidos</p>
						<p class="entidadMobile">
							{{ entidadSelected.descri_entidad }}
						</p>
					</template>
				</el-col>
			</el-row>
		</el-row>
		<el-tabs type="card" :stretch="responsive.isMobile" style="margin-bottom: 0px !important;">
			<el-tab-pane label="Nuevo pedido">
				<el-row :class="!responsive.isMobile ? 'header' : 'headerMobile'" type="flex" justify="center">
					<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18">
						<!-- <h6 v-if="!responsive.isMobile" class="titulo">{{ this.tituloResumen.toUpperCase() }}</h6>
						<el-row type="flex" justify="space-between">
							<el-col :xs="18" :sm="24" :md="24" :lg="24" :xl="24">
								<template v-if="responsive.isMobile">
									<p class="titleMobile">{{ this.tituloResumen }}</p>
									<p class="entidadMobile">
										{{ this.entidadSelected.descri_entidad }}
									</p>
								</template>
							</el-col>
						</el-row> -->

						<el-row>
							<el-card
								:body-style="{ padding: 0 }"
								:style="!responsive.isMobile ? 'height: auto; margin-top: 20px' : 'height: auto; margin-top: 5px'"
							>
								<el-col v-if="!responsive.isMobile" :span="16" class="entidad"> </el-col>
								<el-col
									:xs="21"
									:sm="21"
									:md="6"
									:lg="6"
									:xl="6"
									:style="!responsive.isMobile ? 'padding: 20px' : 'padding: 20px 5px;'"
								>
									<el-input
										placeholder="Buscar productos"
										v-model="patron"
										@change="onChangeSearch"
										suffix-icon="el-icon-search"
										clearable
										size="medium"
										ref="patron"
									>
									</el-input>
								</el-col>
								<el-col v-if="responsive.isMobile" :span="3" style="padding: 15px 10px;">
									<el-button type="text" size="mini" @click="drawer = true">
										<i class="el-icon-linear-funnel" style="font-size: 25px;" />
									</el-button>
								</el-col>
								<el-col :span="2" style="padding: 20px 20px 20px 0px;" v-if="!responsive.isMobile">
									<el-badge :hidden="$store.state.pedidos.carrito.length === 0" :value="$store.state.pedidos.carrito.length">
										<el-button type="info" size="mini" @click="displayCarrito">
											<i class="el-icon-shopping-cart-1"></i>
										</el-button>
									</el-badge>
								</el-col>
							</el-card>
						</el-row>
					</el-col>
				</el-row>
				<el-drawer
					:visible.sync="drawer"
					direction="rtl"
					:size="responsive.isMobile ? '80%' : '310px'"
					:modal="!responsive.isMobile"
					:show-close="!responsive.isMobile"
					:style="{ marginTop: responsive.isMobile ? '60px' : '' }"
				>
					<filtros />
				</el-drawer>
				<el-row justify="end" v-if="responsive.isMobile">
					<el-popover placement="bottom" width="100%" trigger="click" v-if="false">
						<div style="height: 100%;">
							<filtros />
						</div>
						<el-button type="info" slot="reference" size="mini" style="margin: 0px 0px 10px 20px;">
							<i class="el-icon-search"></i>
						</el-button>
					</el-popover>
				</el-row>

				<pedidosProductos />
				<router-view />
				<!-- <template v-if="dashboard">
			<router-view :to="{ name: 'dashboardproductos' }"></router-view>
		</template>
		<template v-if="historial">
			<router-view :to="{ name: 'historial' }"></router-view>
		</template>
		<template v-if="!dashboard && !historial">
			<router-view :to="{ name: 'pedidos' }"></router-view>
		</template> -->
				<carrito :v-if="visibleCarrito" :visible="visibleCarrito"
			/></el-tab-pane>
			<el-tab-pane label="Pedidos realizados"><pedidos-realizados></pedidos-realizados></el-tab-pane>
		</el-tabs>
	</el-container>
</template>
<script>
import Carrito from '@/components/Carrito.vue';
import filtros from '@/components/Filtros.vue';
import PedidosProductos from '@/views/pedidos/PedidosProductos.vue';
import PedidosRealizados from '@/views/pedidos/PedidosRealizados.vue';
export default {
	name: 'productos',
	inject: ['responsive'],
	components: {
		Carrito,
		PedidosProductos,
		filtros,
		PedidosRealizados,
	},
	data() {
		return {
			drawer: false,
			filter: {
				patron: '',
				familia_id: '',
				subfamilia_id: '',
				unidad: '',
				presentacion_id: '',
				rubro_id: '',
				subrubro_id: '',
				linea_id: '',
				marca_id: '',
				es_nuevo: false,
				es_promocion: false,
			},
			patron: '',
			visibleCarrito: false,
		};
	},
	computed: {
		tituloResumen() {
			//return this.$route.name;
			return 'INGRESO DE PEDIDOS DE CLIENTES';
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		entidadSelected() {
			return this.$store.state.perfil.entidadSelected;
		},
	},
	methods: {
		armoLLamada(filter, start, limit, page) {
			filter.patron = this.patron;
			let filtros = filter;
			this.filter = filtros;
			this.callProductos({ params: { filtros, start, limit, page } });
		},
		onChangeSearch(value, select) {
			this.filter.patron = this.patron;
			this.start = 0;
			this.page = 1;
			this.limit = 6;
			let filtros = this.filter,
				start = this.start,
				limit = this.limit,
				page = this.page;
			this.callProductos({ params: { filtros, start, limit, page } });
			this.$store.dispatch('saveFilter', this.filter).then(() => {
				this.$store.dispatch('loadAllProductos').then(() => {});
			});
		},
		displayCarrito() {
			//this.$store.dispatch('loadTorigen');
			//this.$store.dispatch('loadToperacion');
			//this.$store.dispatch('loadDentregas');
			this.visibleCarrito = !this.visibleCarrito;
		},

		callProductos(params) {
			this.$store.dispatch('loadProductos', params);
		},
	},
};
</script>
<style lang="scss">
#pedidos {
	.mobile {
		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 100%;
		}
	}
	.titleMobile {
		font-size: 14px !important;
		padding-left: 10px;
		padding-top: 10px;
		margin: 0;
	}
	.header {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		margin-bottom: 20px;
		padding-bottom: 20px;
		h6 {
			font-size: 18px;
		}
		.entidad {
			font-family: 'Open Sans', sans-serif;
			font-size: 23px;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.25px;
			font-stretch: normal;
			line-height: 40px;
			padding: 20px;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}
	}
	.headerMobile {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		padding-bottom: 10px;
		padding-top: 10px;
		h6 {
			font-size: 18px;
		}
		.entidadMobile {
			font-family: 'Open Sans', sans-serif;
			padding-left: 10px;
			font-size: 15px;
			font-weight: bold;
			letter-spacing: -0.25px;
			font-stretch: normal;
			margin: 0;
			padding-bottom: 10px;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}
	}
	.el-tabs__header {
		margin: 0px !important;
	}
	.el-tabs {
		position: relative;
		top: 1px;
		.el-tabs__header {
			margin: 0;
			.el-tabs__nav {
				border: 0;
			}
		}
		.el-tabs__item {
			background-color: var(--main-color);
			color: #fff;
			&.is-active {
				background-color: #fff;
				color: var(--main-color);
			}
		}
	}
}
</style>
